import './Financials.scss';
import Component from './Financials.js';
export default Component;
